export const QA_NAME_SUBMENU = 'SubmenuItem'
